module.exports = __webpack_public_path__ + "img/feature-2.64d31bee.svg";